import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { DropDownList } from "../Components/DropDownList";
import { useLocation } from "react-router-dom";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { ErrorNotFound } from "./ErrorNotFound";
import { useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";

function EjeEditar() {
  const { state } = useLocation();
  const { id } = state;
  const [isLoading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [tipoDeEje, setTipoDeEje] = useState({ Id: "", Nombre: "" });
  const { user } = useAuth();
  const [eje, setEje] = useState({
    tipoDeEje: "",
    id: null,
    nombre: "",
  });
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/TipoDeEje",
    pageState: {},
  });
  // try {
  //   const { id } = state;
  //   console.log("On try")
  //   console.log(state)
  //   setId(id);
  // } catch (error) {
  //   console.log(error)
  // }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEje({
      ...eje,
      [name]: value,
    });
  };
  if (isLoading) {
    instance
      .get("/eje/getById/" + id)
      .then((res) => {
        setEje(res.data);
        setTipoDeEje({ Id: eje.tipoDeEje, Nombre: "" });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: id,
      tipoDeEje: tipoDeEje.Id,
      nombre: addEspaceCharacters(info.nombre.value),
      userId: user.id,
    };
    instance
      .put("eje/update", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se han actualizado los datos del eje de forma exitosa.`,
          redirect: true,
          page: "/TipoDeEjeDetalle",
          pageState: { id: tipoDeEje.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <DropDownList
              required
              title="Tipo de eje"
              endpoint={"/tipoDeEje/listActiveAndActual/" + eje.tipoDeEje}
              selectedItem={tipoDeEje}
              setSelectedItem={setTipoDeEje}
              selected={eje.tipoDeEje}
            />
          </Grid>
          <Grid item>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              value={eje.nombre}
              autoFocus
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              size="medium"
              variant="contained"
              sx={{ mt: 3 }}
              color="success"
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { EjeEditar };
